export enum FilterTypes {
  STATUS = 'STATUS',
  RATINGS = 'RATINGS',
  PAYMENT_METHODS = 'PAYMENT_METHODS',
  DELIVERY_TYPES = 'DELIVERY_TYPES',
  PERIOD = 'PERIOD',
  SEARCH = 'SEARCH',
}

export enum FilterStoreProps {
  STATUS = 'orderStatus',
  RATINGS = 'ratings',
  PAYMENT_METHODS = 'paymentMethods',
  DELIVERY_TYPES = 'deliveryTypes',
  PERIOD = 'period',
  SEARCH = 'search',
  COURIER_EMAIL = 'courierEmail',
  PAGE = 'page',
  PAGE_SIZE = 'pageSize',
  HAS_MORE_ORDERS = 'hasMoreOrders',
}
